import {Component, Input, OnChanges, OnInit, SimpleChanges, NgZone} from '@angular/core';
import {ContenutoGenericoService} from 'src/app/service/contenuto-generico.service';
import {ContenutoGenerico} from 'src/app/model/contenuto-generico';
import {Search} from 'src/app/common/search';
import {AllegatoService} from 'src/app/service/allegato.service';
import {Allegato} from 'src/app/model/allegato';
import {DocumentoService} from 'src/app/service/documento.service';
import {Documento} from 'src/app/model/documento';
import {concatMap, map} from 'rxjs/operators';
import {from} from 'rxjs';
import {DOCS_REPLACE, DOCS_REPLACE_NAME} from '../../constants/constants';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router'; // RxJS 6 syntax


@Component({
    selector: 'app-pages-with-tabs-time',
    templateUrl: './pages-with-tabs-time.component.html',
})
export class PagesWithTabsTimeComponent implements OnInit, OnChanges {

    @Input() element: ContenutoGenerico;

    private _element: string;
    public allegato: Allegato;
    public componentiCollegati: Array<ContenutoGenerico>;
    public loading: boolean;
    public listeDocumenti: Array<{ documenti: Array<Documento>; anno: number }>;
    public lingua: string;
    public year: number;
    public index = -1;
    public base_path: string;


    constructor(private location: Location,
                private contenutoService: ContenutoGenericoService,
                private documentoService: DocumentoService,
                private allegatoService: AllegatoService,
                private activatedRoute: ActivatedRoute) {
        this.base_path = window.location.pathname;
    }

    handleChange(e) {
        this.index = e.index;
        const path = this.base_path + '?year=' + this.listeDocumenti[this.index].anno;
        this.year = this.listeDocumenti[this.index].anno;
        window.history.replaceState({}, '', path);
    }


    ngOnChanges(changes: SimpleChanges) {
        this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
        if (this.element) {
            this.lingua = this.element.lang;
            if (this.element.contenitore != null) {
                this.contenutoService.search._.contenitore = this.element.contenitore;
            } else {
                this.contenutoService.search._.contenitore = this.element.uuid;
            }
        }
        this.contenutoService.search._sort = 'ordine ASC';
        this.contenutoService.search._.lang = this.lingua;
        this.contenutoService.getAllList().subscribe(componentiCollegati => {
                this.componentiCollegati = componentiCollegati;
                this.documentoService.search._.lang = this.lingua;
                this.documentoService.search._sort = 'data_pubblicazione DESC, ora_pubblicazione DESC';
                this.documentoService.search._.tipologia = this.element.uuid;
                const ob = [];
                const annoCorrente: number = new Date().getFullYear();
                const annoUltimo: number = annoCorrente - 10;
                for (let i: number = annoCorrente; i > annoUltimo; i--) {
                    this.listeDocumenti = [];
                    this.documentoService.search._contains.anno = i;
                    ob.push(this.documentoService.getAllList().pipe(
                        map(documentiAnnui => {
                                if (documentiAnnui.length > 0) {
                                    const documenti = documentiAnnui;
                                    const anno: number = documenti[0].anno;
                                    this.listeDocumenti.push({documenti, anno});
                                }
                                this.loading = false;
                            },
                            err => {
                                this.loading = false;
                            })
                        )
                    );
                }
                from(ob).pipe(concatMap(res => res)).subscribe(
                    () => {
                        let i = 0;
                        for (; i < this.listeDocumenti.length; i++) {
                            if (this.listeDocumenti[i].anno === this.year) {
                                break;
                            }
                        }
                        // lascio che il tab view disegni la lista completa, altrimenti l'active index non ha effetto.
                        setTimeout(
                            () => {
                                this.index = i;
                            },
                            1000
                        );
                    }
                );
            },
            err => {
                this.loading = false;
            });

    }

    ngOnInit() {
        this.activatedRoute.queryParamMap
            .subscribe(queryParams => {
                this.year = +queryParams.get('year');
                if (!this.year) {
                    this.year = new Date().getFullYear();
                }
            });
        this.lingua = this.element.lang;
        this.documentoService.search = new Search<Documento>(Documento);
    }

    public download(uuid_allegato: string) {
        this.allegatoService.find(uuid_allegato).subscribe(
            allegato => {
                this.allegato = allegato;
                if (allegato != null) {
                    window.open(DOCS_REPLACE(this.allegato.uuid), '_blank');
                }
            });
    }

    public getOra(date: string): string {
        if (date) {
            const ore = date.substring(11, 16);
            return ore;
        }
        return null;
    }

    path(uuid_allegato: string, titolo: string, estensione: string) {
        return DOCS_REPLACE_NAME(uuid_allegato, this.slug(titolo) + this.estensione(estensione));
    }


    estensione(estensione: string): string {
        switch (estensione) {
            case 'application/zip':
                return '.zip';
            case 'application/x-zip-compressed':
                return '.zip';
            case 'application/xhtml+xml':
                return '.xhtml';
            default:
                return '.pdf';
        }
    }


    slug(field: string) {
        if (field == null) {
            return null;
        }
        field = field.replace(/^\s+|\s+$/g, ''); // trim
        field = field.toLowerCase();
        return field.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
    }
}

